var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainingBoldIconSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 84,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.752 21.96H0V0h78v21.96H53.248V84H24.752V21.96z",
    fill: "#453737"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3OCIgaGVpZ2h0PSI4NCIgdmlld0JveD0iMCAwIDc4IDg0IiBmaWxsPSJub25lIj4KICAgIDxwYXRoIGQ9Ik0yNC43NTIzIDIxLjk2SDBWMEg3OFYyMS45Nkg1My4yNDc3Vjg0SDI0Ljc1MjNWMjEuOTZaIiBmaWxsPSIjNDUzNzM3Ii8+Cjwvc3ZnPgo=";
export { SvgTrainingBoldIconSvg as ReactComponent };